import React, { useState } from 'react';

const API = 'https://khepri.tech/api/v1';

function TenderCheck() {
  const [inn, setInn] = useState('');
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem('khepri_token');

  const check = async (e) => {
    e.preventDefault();
    if (!inn.trim() || loading) return;

    setLoading(true);
    setResult(null);

    try {
      const res = await fetch(API + '/tender/check?inn=' + inn, {
        headers: { Authorization: 'Bearer ' + token },
      });
      const data = await res.json();
      setResult(data);
    } catch (err) {
      setResult({
        inn,
        status: 'error',
        verdict: '❌ Ошибка проверки',
        risks: [{ severity: 'high', description: 'Не удалось получить данные' }],
        checks: [],
      });
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    if (status === 'critical') return '#EF4444';
    if (status === 'high') return '#F59E0B';
    if (status === 'ok') return '#10B981';
    return '#94A3B8';
  };

  const downloadReport = () => {
    if (!result) return;
    const report = `ПРОВЕРКА ПО СТ. 31 44-ФЗ
Дата: ${new Date().toLocaleString('ru-RU')}

ИНН: ${result.inn}
Название: ${result.name || 'Не указано'}
ОГРН: ${result.ogrn || 'Не указан'}
КПП: ${result.kpp || 'Не указан'}
Директор: ${result.director || 'Не указан'}
Вердикт: ${result.verdict}

Проверки:
${(result.checks || []).map(c => `${c.status} ${c.name} — ${c.detail}`).join('\n')}

Риски:
${(result.risks || []).map(r => `[${r.severity}] ${r.description}`).join('\n') || 'Рисков не обнаружено'}

РНП (Реестр недобросовестных поставщиков):
Проверить вручную: ${result.eis_link}

ФССП: ${result.fssp_link}
КАД: ${result.kad_link}
ЕФРСБ: ${result.efrsb_link}

Отчёт сгенерирован Khepri
`;
    const blob = new Blob([report], { type: 'text/plain;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `Проверка_44-ФЗ_${result.inn}.txt`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  return (
    <div>
      <h2 style={{ color: '#F7DE8A' }}>🛡️ Проверка по ст. 31 44-ФЗ</h2>
      <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 4, marginBottom: 16 }}>
        Проверьте контрагента на соответствие требованиям ст. 31 44-ФЗ перед участием в госзакупках.
      </p>

      <form onSubmit={check} style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        <input
          value={inn}
          onChange={e => setInn(e.target.value)}
          placeholder="ИНН (10 или 12 цифр)"
          style={{ flex: 1, padding: 12, background: '#0F172A', border: '1px solid #8A6636', borderRadius: 8, color: '#F8FAFC', fontSize: 14 }}
          disabled={loading}
        />
        <button
          type="submit"
          disabled={loading}
          style={{ padding: '12px 24px', background: '#F7DE8A', color: '#0F172A', border: 'none', borderRadius: 8, cursor: loading ? 'default' : 'pointer', fontWeight: 700, opacity: loading ? 0.6 : 1 }}
        >
          {loading ? '⏳ Проверяем...' : 'Проверить'}
        </button>
      </form>

      {result && (
        <div style={{ padding: 20, background: '#1E293B', borderRadius: 12, border: `2px solid ${getStatusColor(result.status)}` }}>
          <div style={{ marginBottom: 20, padding: 16, background: getStatusColor(result.status), color: '#fff', borderRadius: 8, textAlign: 'center' }}>
            <div style={{ fontSize: 20, fontWeight: 700 }}>{result.verdict}</div>
            {result.name && <div style={{ marginTop: 6, fontSize: 14, opacity: 0.9 }}>{result.name}</div>}
          </div>

          {(result.ogrn || result.kpp || result.director) && (
            <div style={{ marginBottom: 20, padding: 12, background: '#0F172A', borderRadius: 8, fontSize: 13 }}>
              {result.ogrn && <div style={{ color: '#94A3B8' }}>ОГРН: {result.ogrn}</div>}
              {result.kpp && <div style={{ color: '#94A3B8' }}>КПП: {result.kpp}</div>}
              {result.director && <div style={{ color: '#94A3B8' }}>Директор: {result.director}</div>}
            </div>
          )}

          <h3 style={{ color: '#F7DE8A', marginBottom: 12 }}>📋 Проверки по ст. 31 44-ФЗ</h3>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 20 }}>
            {(result.checks || []).map((c, i) => (
              <div key={i} style={{ padding: 12, background: '#0F172A', borderRadius: 8, border: '1px solid #8A6636' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 }}>
                  <span style={{ color: '#F8FAFC', fontSize: 13 }}>
                    {c.status} {c.name}
                  </span>
                </div>
                <div style={{ color: '#94A3B8', fontSize: 12, marginTop: 4 }}>{c.detail}</div>
              </div>
            ))}
          </div>

          {(result.risks || []).length > 0 && (
            <>
              <h3 style={{ color: '#F7DE8A', marginBottom: 12 }}>⚠️ Обнаруженные риски</h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8, marginBottom: 20 }}>
                {result.risks.map((r, i) => (
                  <div key={i} style={{ padding: 10, background: 'rgba(239,68,68,0.1)', borderRadius: 8, borderLeft: `3px solid ${r.severity === 'critical' ? '#EF4444' : '#F59E0B'}`, fontSize: 13 }}>
                    <span style={{ color: r.severity === 'critical' ? '#EF4444' : '#F59E0B', fontWeight: 600 }}>[{r.severity}]</span>
                    <span style={{ color: '#94A3B8', marginLeft: 8 }}>{r.description}</span>
                  </div>
                ))}
              </div>
            </>
          )}

          <div style={{ padding: 12, background: 'rgba(99,102,241,0.1)', borderRadius: 8, border: '1px solid #6366F1', marginBottom: 20 }}>
            <strong style={{ color: '#6366F1' }}>🔍 Ручная проверка</strong>
            <p style={{ color: '#94A3B8', fontSize: 13, marginTop: 6 }}>
              Проверьте участника в РНП и других реестрах:
            </p>
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 8 }}>
              <a href={result.eis_link} target="_blank" rel="noopener noreferrer" style={{ padding: '8px 16px', background: '#6366F1', color: '#fff', borderRadius: 8, textDecoration: 'none', fontWeight: 600, fontSize: 12 }}>
                🔗 ЕИС (РНП)
              </a>
              <a href={result.fssp_link} target="_blank" rel="noopener noreferrer" style={{ padding: '8px 16px', background: '#8A6636', color: '#fff', borderRadius: 8, textDecoration: 'none', fontWeight: 600, fontSize: 12 }}>
                🔗 ФССП
              </a>
              <a href={result.kad_link} target="_blank" rel="noopener noreferrer" style={{ padding: '8px 16px', background: '#8A6636', color: '#fff', borderRadius: 8, textDecoration: 'none', fontWeight: 600, fontSize: 12 }}>
                🔗 КАД
              </a>
              <a href={result.efrsb_link} target="_blank" rel="noopener noreferrer" style={{ padding: '8px 16px', background: '#8A6636', color: '#fff', borderRadius: 8, textDecoration: 'none', fontWeight: 600, fontSize: 12 }}>
                🔗 ЕФРСБ
              </a>
            </div>
          </div>

          <button onClick={downloadReport} style={{ padding: '10px 20px', background: '#F7DE8A', color: '#0F172A', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>
            📥 Скачать отчёт
          </button>

          <p style={{ color: '#94A3B8', fontSize: 11, marginTop: 16 }}>
            ⚠️ Результат носит информационный характер. Для подтверждения должной осмотрительности рекомендуется запросить выписку из «Сервиса оценки» ФНС.
          </p>
        </div>
      )}
    </div>
  );
}

export default TenderCheck;